// extracted by mini-css-extract-plugin
module.exports = {"root":"second_root__3xPrD","check":"second_check__gkOPQ"};